import OrDelimiter from './or-delimiter';

export default OrDelimiter;
